import { publicSettingApi } from './clients';
import { GetProductDetailParams } from '@teko/discovery';

export const productService = {
  bffGetProduct: (params: GetProductDetailParams) => {
    return publicSettingApi.get('/sku-details', { params }).then(({ data }) => {
      // convert new format to old format ~ backward compatible
      const { data: product, ...rest } = data || {};
      return {
        ...rest,
        result: {
          product,
        },
      };
    });
  },
};
